// extracted by mini-css-extract-plugin
export default {"root":"MoreMessageActionsTool_root__ct1zS"};